module.exports = __webpack_public_path__ + "img/three1Red.f5a98112.jpg";